/**
 * Toast Component
 *
 * Individual toast notification with icon and close button.
 * Supports success, error, warning, and info variants.
 */

import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import './Toast.css';

const ICONS = {
  success: 'mdi:check-circle',
  error: 'mdi:close-circle',
  warning: 'mdi:alert-circle',
  info: 'mdi:information',
};

const Toast = ({ id, type = 'info', message, onClose }) => {
  const [isExiting, setIsExiting] = useState(false);

  const handleClose = () => {
    setIsExiting(true);
    // Wait for animation to complete
    setTimeout(() => {
      onClose?.();
    }, 200);
  };

  return (
    <div
      className={`ds-toast ds-toast--${type} ${isExiting ? 'ds-toast--exiting' : ''}`}
      role="alert"
      aria-live="polite"
    >
      <div className="ds-toast__icon">
        <Icon icon={ICONS[type]} width={20} height={20} />
      </div>
      <div className="ds-toast__content">
        <p className="ds-toast__message">{message}</p>
      </div>
      <button
        className="ds-toast__close"
        onClick={handleClose}
        aria-label="Close notification"
      >
        <Icon icon="mdi:close" width={18} height={18} />
      </button>
    </div>
  );
};

export default Toast;
